import React from "react";

const PricingScreen = ({ onSelectPlan, onClose }) => {
  const plans = [
    {
      id: "basic",
      name: "基礎版 (Basic)",
      price: "免費",
      desc: "適合個人體驗試用",
      features: ["✅ 單頁 Flex 編輯", "✅ 基礎元件庫", "❌ 無法匯出 JSON", "❌ 無法直接發送 LINE"],
      recommend: false,
    },
    {
      id: "pro",
      name: "進階版 (Pro)",
      price: "$100 / 月",
      desc: "解鎖完整功能，適合行銷人員",
      features: ["✅ 無限頁面輪播", "✅ 完整圖庫支援", "✅ 一鍵匯出 JSON", "✅ 直接發送至 LINE 好友"],
      recommend: true,
    },
    {
      id: "enterprise",
      name: "高階版 (Enterprise)",
      price: "洽詢業務",
      desc: "適合大型企業與團隊協作",
      features: ["✅ 包含進階版所有功能", "✅ 專屬 API 串接", "✅ 團隊權限管理", "✅ 7x24 專人支援"],
      recommend: false,
    },
  ];

  return (
    <div
      style={{
        width: "100vw", minHeight: "100vh",
        background: "var(--bg-main)", color: "#fff",
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        padding: "40px 20px", position: "relative"
      }}
    >
      {/* ✅ 右上角關閉按鈕 */}
      <button
        onClick={onClose}
        style={{
          position: "absolute", top: 30, right: 30,
          width: 40, height: 40,
          background: "rgba(255,255,255,0.1)", color: "#fff",
          border: "none", borderRadius: "50%",
          fontSize: 20, cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "background 0.2s"
        }}
        onMouseOver={(e) => e.target.style.background = "rgba(255,255,255,0.2)"}
        onMouseOut={(e) => e.target.style.background = "rgba(255,255,255,0.1)"}
      >
        ✕
      </button>

      <h1 style={{ fontSize: 32, marginBottom: 10, fontWeight: "bold", textAlign: "center" }}>
        選擇適合您的方案
      </h1>
      <p style={{ color: "#aaa", marginBottom: 40, textAlign: "center" }}>
        升級以解鎖 Flex Message 編輯器的強大潛力
      </p>

      <div style={{ display: "flex", gap: 20, flexWrap: "wrap", justifyContent: "center", maxWidth: 1200 }}>
        {plans.map((plan) => (
          <div
            key={plan.id}
            style={{
              width: 300,
              background: plan.recommend ? "rgba(59, 130, 246, 0.1)" : "var(--bg-panel)",
              border: plan.recommend ? "2px solid var(--accent-color)" : "1px solid var(--border-color)",
              borderRadius: 16, padding: 30,
              display: "flex", flexDirection: "column",
              position: "relative",
              transform: plan.recommend ? "scale(1.05)" : "scale(1)",
              boxShadow: plan.recommend ? "0 20px 40px rgba(59, 130, 246, 0.2)" : "0 10px 20px rgba(0,0,0,0.3)",
              transition: "transform 0.3s",
              zIndex: plan.recommend ? 2 : 1,
            }}
          >
            {plan.recommend && (
              <div
                style={{
                  position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)",
                  background: "var(--accent-color)", color: "#fff",
                  padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: "bold",
                }}
              >
                最熱門選擇
              </div>
            )}

            <h3 style={{ fontSize: 20, marginBottom: 5 }}>{plan.name}</h3>
            <p style={{ fontSize: 13, color: "#888", marginBottom: 20, minHeight: 40 }}>{plan.desc}</p>
            <div style={{ fontSize: 28, fontWeight: "bold", marginBottom: 20, color: plan.recommend ? "var(--accent-color)" : "#fff" }}>
              {plan.price}
            </div>

            <div style={{ flexGrow: 1, marginBottom: 30 }}>
              {plan.features.map((feature, idx) => (
                <div key={idx} style={{ fontSize: 14, marginBottom: 10, color: "#ddd" }}>{feature}</div>
              ))}
            </div>

            <button
              onClick={() => onSelectPlan(plan.id)}
              style={{
                width: "100%", padding: "12px",
                borderRadius: 8, border: "none",
                background: plan.recommend ? "var(--accent-color)" : "#333",
                color: "#fff", fontWeight: "bold", cursor: "pointer",
                transition: "background 0.2s",
              }}
              onMouseOver={(e) => {
                if (plan.recommend) e.target.style.background = "var(--accent-hover)";
                else e.target.style.background = "#444";
              }}
              onMouseOut={(e) => {
                if (plan.recommend) e.target.style.background = "var(--accent-color)";
                else e.target.style.background = "#333";
              }}
            >
              {plan.price === "免費" ? "開始試用" : "立即訂閱"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingScreen;